module.exports = __webpack_public_path__ + "img/aircraftExchange.cac5a7dd.svg";